export default "__VITE_PUBLIC_ASSET__444f9f1c__"